import React from 'react';

import { getClass } from 'utils/component-helpers';

import { handleImageError } from '../../base/common/utils';
import placeholderImage from '../../../images/product_placeholder.png';

import './merchant-logo.scss';

const merchantLogo = React.forwardRef(({merchant, selectMerchant, insightsType, resetCarousel}, ref) => {
	const slug = merchant.slug;

	function onImageError(e, slug) {
		handleImageError(e);
		const logoContainer = document.getElementsByClassName(`logo ${slug}`);
		logoContainer[0].classList.add('placeholder');
	}

	return (
		<div
			className={getClass(`merchant-logo-container ${insightsType}`, {
				'hidden': merchant.hidden,
			})}
			ref={ref}>
			<div
				className={getClass(`merchant-logo ${slug}`, {
					'selected': !resetCarousel && merchant.selected,
				})}
				onClick={() => selectMerchant(slug)}>
				<img className={`logo ${slug}`}
					src={merchant.logo_url || placeholderImage} alt={`${slug}`}
					onError={(e) => onImageError(e, slug)}
				/>
			</div>
		</div>
	);
});

export default merchantLogo;
